import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Token } from "../../types/Token";
import { UsuarioLogadoGet, UsuarioLogout } from "../../utils/usuarioEstaLogado";
import configUrls from "../../config/configUrls";
import { useIsSaber } from "../../utils/qualSistema";

interface TokenData {
  exp: number; // Timestamp de expiração do token
}

export function useTokenService() {
  const navigate = useNavigate();
  const tokenContext: Token = UsuarioLogadoGet();
  const [token, setToken] = useState<string | null>(tokenContext.token);
  const isSaber = useIsSaber(); // Aqui você pode chamar o hook diretamente
  
  useEffect(() => {
    // Atualiza o token quando houver mudanças no contexto
    setToken(tokenContext.token);
  }, [tokenContext.token]);

  const decodeToken = (token: string): TokenData => {
    const payload = token.split(".")[1];
    const decoded = JSON.parse(atob(payload));
    return decoded as TokenData;
  };

  const checkTokenValidity = () => {
    if (token && isTokenExpired()) {
      handleTokenExpired();
    }
  };

  const handleTokenExpired = () => {
    // Limpa o token no contexto ou localmente
    setToken(null);
    // Redireciona para a página de login
    UsuarioLogout();

    if (isSaber) {
      window.location.href = configUrls.SABER_LOGIN;
    } else {
      window.location.href = configUrls.SITE_LOGIN;
    }
  };

  const getTimeToExpiration = () => {
    if (!token) return null;

    const decodedToken = decodeToken(token);
    const expirationTime = decodedToken.exp * 1000; // Convertendo para milissegundos
    const now = new Date().getTime();
    const expiresIn = expirationTime - now;

    // Convertendo milissegundos para minutos
    return Math.floor(expiresIn / 60000); // 1 minuto = 60000 milissegundos
  };

  const getTimeToExpirationFormatted = () => {
    if (!token) return null;
    const timeRemaining = getTimeToExpiration();
    return formatTime(timeRemaining);
  };

  const isTokenExpired = () => {
    if (!token) return true;

    const decodedToken = decodeToken(token);
    const expirationTime = decodedToken.exp * 1000; // Convertendo para milissegundos
    const now = new Date().getTime();

    return now > expirationTime;
  };

  const formatTime = (timeInMinutes: number | null) => {
    if (timeInMinutes === null) {
      return "Token não definido";
    } else if (timeInMinutes <= 0) {
      return "Token expirado";
    } else {
      const hours = Math.floor(timeInMinutes / 60);
      const minutes = timeInMinutes % 60;
      return `${hours}h ${minutes}min`;
    }
  };

  return {
    token,
    getTimeToExpiration,
    isTokenExpired,
    checkTokenValidity,
    getTimeToExpirationFormatted,
  };
}
